<template>
	<div class="tw-w-full tw--mx-3">
		<app-table
			class="is-not-selectable no-main-list"
			:columns="columns"
			:rows="rows"
			:filter-columns="false"
			title="COMPAÑÍAS:">
			<template slot="rows" slot-scope="props">
				<td style="width: 300px; text-align: start; padding-left: 40px;" v-show="showRow(columns, 1)">{{ props.row.name }}</td>
				<td v-show="showRow(columns, 2)">{{ props.row.aclCode }}</td>
				<td v-show="showRow(columns, 3)">{{ props.row.additionalInformation && props.row.additionalInformation.phone ? props.row.additionalInformation.phone : null }}</td>
				<td v-show="showRow(columns, 4)" @click.stop="stopClick">
					<v-layout wrap>
						<app-tooltip-button
							img="/static/img/edit.svg"
							text="Editar"
							@click-icon="handlerEditCompany(props.row)"
						/>
					</v-layout>
				</td>
			</template>
		</app-table>
		<edit-company-dialog
			ref="editCompany"
			:company="focusedCompany"
			:platforms="platforms.data"
			@saveDataCompany="saveDataCompany"></edit-company-dialog>
	</div>
</template>

<script>
import PCard from '@/modules/shared/components/ui/Card/p-card';
import PEmptyMessage from '@/modules/shared/components/ui/p-empty-message';
import PButton from '@/modules/shared/components/ui/p-button';
import PHorizontalDivider from '@/modules/shared/components/ui/p-horizontal-divider';
import editCompanyDialog from '@/components/configuration/companies/edit-company-dialog';
import { pathOr } from 'ramda';
import { mapState } from 'vuex';

export default {
	name: 'companies',
	data() {
		return {
			columns: [
				{
					id: 1,
					name: 'NOMBRES',
					value: 'name',
					visible: true,
					checked: true,
					sortCheck: true,
					fieldName: 'last_name',
					color: 'gray',
				},
				{
					id: 2,
					name: 'CÓDIGO',
					value: 'code',
					visible: true,
					checked: true,
				},
				{
					id: 3,
					name: 'TELÉFONO',
					value: 'phone',
					visible: true,
					checked: true,
				},
				{
					id: 4,
					name: 'ACCIONES',
					value: 'actions',
					visible: true,
				},
			],
			rows: [],
			focusedCompany: {},
		};
	},
	created() {
		this.loadCompanies();
		this.$store.dispatch('jobEvaluation/loadPlatforms');
	},
	components: {
		PCard,
		PEmptyMessage,
		PButton,
		PHorizontalDivider,
		editCompanyDialog,
	},
	methods: {
		async loadCompanies() {
			try {
				const { data: response } = await this.$httpPraktiko.get('/companies');
				this.rows = response;
			} catch (error) {
				this.showGenericError();
			}
		},
		async handlerEditCompany(row) {
			try {
				const { data: response } = await this.$httpPraktiko.get(`/companies/detail/${row.id}`);
				this.focusedCompany = response;
				this.$refs.editCompany.open();
			} catch (error) {
				this.showGenericError();
			}
		},
		async saveDataCompany(dataCompany) {
			try {
				await this.$httpPraktiko.patch(`/companies/${this.focusedCompany.id}`, dataCompany);
				this.showNotification('Compañía editada correctamente');
				this.loadCompanies();
			} catch (error) {
				this.showGenericError();
			}
		},
	},
	computed: {
		...mapState('jobEvaluation', {
			platforms: pathOr([], ['supplies', 'generalData', 'platforms']),
		}),
	},
};
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/pages/configuration/companies.vue